<form nestableForm data-testid="planStartWindow">
  <div #controlsSibling [height]="15"></div>
  <div class="close-cnt cnt-row">
    <div class="filler"></div>
    <close-btn (click)="onClose()"></close-btn>
    <div [width]="10"></div>
  </div>
  <div class="cnt-column-centered">
    <div [height]="20"></div>
    <div class="h1Font" i18n>{{ 'PLAN_SETTINGS' | translate }}</div>
    <div [height]="10"></div>
    <div class="p1Font" style="text-align: center" i18n>
      {{ 'ENTER_YOUR_PLAN_SETTINGS' | translate }}
    </div>

    <div [height]="50"></div>

    <div class="centreDiv">
      <div [height]="20"></div>
      <infoPopUp
        [pFieldID]="'NamePlan'"
        [logoText]="'Name your plan'"
        (infoOpened)="closeOtherInfoPanels($event)"
        [dCreator]="parent.getDialogCreator()"
      >
      </infoPopUp>
      <div [height]="5"></div>
      <div class="controlsPadding" style="align-items: stretch">
        <img-text
          [hint]="'MY_BUSINESS_PLAN' | translate"
          i18n-hint  
          name="newPlanName"
          [(ngModel)]="newPlan.planName"
          [backgroundColor]="'white'"
          (ngModelChange)="onInputTextChange($event)"
          [height]="40"
          [width]="300"
          [fieldClass]="'large-field'"
          [maxlen]="100"
          [testId]="'edPlanName'"
          label=""
        >
        </img-text>
      </div>

      <div [height]="20"></div>
      <div class="line-thin g4Background"></div>
      <div [height]="20"></div>

      <infoPopUp
        [pFieldID]="'StartDateAndLength'"
        [logoText]="forecastStartDateText | translate"
        (infoOpened)="closeOtherInfoPanels($event)"
        [dCreator]="parent.getDialogCreator()"
      >
      </infoPopUp>
      <div [height]="5"></div>
      <div class="controlsPadding" style="align-items: stretch">
        <div class="cnt-row-centered">
          <combo
            hint=""
            name="edStartMonth"
            [hasOutline]="true"
            [backgroundColor]="'white'"
            [ComboData]="monthsComboItems"
            [showImg]="false"
            [ngModel]="newPlan.planStartStr | callback : getMonth"
            [width]="128"
            [height]="30"
            [inputTextClass]="'small-field'"
            (changeCaller)="handleStartDateMonthComboChange($event)"
            label=""
            testId="edStartMonth"
          >
          </combo>
          <div [width]="5"></div>
          <div>
            <combo
              hint=""
              name="edYear"
              [hasOutline]="true"
              [backgroundColor]="'white'"
              [ComboData]="yearComboItems"
              [showImg]="false"
              [ngModel]="newPlan.planStartStr | callback : getYearId"
              label=""
              [width]="85"
              [height]="30"
              [inputTextClass]="'small-field'"
              (changeCaller)="handleStartDateYearComboChange($event)"
              testId="edYear"
            >
            </combo>
          </div>
          <div [width]="30"></div>
          <span>for</span>
          <div [width]="5"></div>
          <combo
            hint=""
            name="edDuration"
            [hasOutline]="true"
            [backgroundColor]="'white'"
            [ComboData]="years"
            [showImg]="false"
            [(ngModel)]="durationYear"
            [labelClass]="'newplan-lab'"
            [width]="100"
            [height]="30"
            [inputTextClass]="'small-field'"
            (changeCaller)="onStartPlanDataChange()"
            label=""
            testId="newPlanDuration"
          >
          </combo>
        </div>
      </div>

      <div
        *ngIf="errorMessage"
        class="warning-text"
        data-testid="newPlanErrorMessage"
      >
        {{ errorMessage }}
      </div>

      <div [height]="20"></div>
      <div class="line-thin g4Background"></div>
      <div class="block">
        <div [height]="20"></div>
        <infoPopUp
          [pFieldID]="'VatTaxSystem'"
          [logoText]="taxSystemLogoText | translate"
          (infoOpened)="closeOtherInfoPanels($event)"
          [dCreator]="parent.getDialogCreator()"
        >
        </infoPopUp>
        <div [height]="3"></div>
        <div class="controlsPadding" style="align-items: stretch">
          <div class="cnt-row-centered">
            <combo
              hint=""
              name="edVatCalcOption"
              [hasOutline]="true"
              [backgroundColor]="'white'"
              [ComboData]="onOrOffByDefault"
              [showImg]="false"
              [(ngModel)]="aVatText"
              label=""
              [width]="85"
              [height]="30"
              [inputTextClass]="'small-field'"
              testId="edVatCalcOption"
            >
            </combo>
          </div>
        </div>
      </div>

      <div [height]="20"></div>
      <div class="line-thin g4Background"></div>
      <div [height]="20"></div>

      <div class="cnt-row-centered">
        <infoPopUp
          [pFieldID]="'StartCheck'"
          [logoText]="''"
          (infoOpened)="closeOtherInfoPanels($event)"
          [dCreator]="parent.getDialogCreator()"
        >
        </infoPopUp>
        <div [height]="5"></div>
        <slide-switcher
          #forecastSwitch
          name="isFillForecasts"
          [label]="xeroHistoricalDataLabelText | translate"
          [(ngModel)]="data.isFillForecasts"
          (switch)="onSwitchForecast()"
          [testId]="'switcher-forecast-div'"
        >
        </slide-switcher>
      </div>
      <div #tableDiv style="width: 100%">
        <div [height]="15"></div>
        <div
          class="line g4Background"
          style="margin-left: 30px; width: auto"
        ></div>

        <div [height]="20"></div>

        <table class="data-table controlsPadding">
          <tr>
            <td [width]="200" class="h4Font" i18n>{{ 'CATEGORY' | translate }}</td>
            <td [width]="230" class="h4Font" i18n>{{ 'USE_FIGURES_BASED_ON' | translate }}</td>
            <td *ngIf="notAllAdjustsBlank()" [width]="100" class="h4Font">
              Adjust by
            </td>
          </tr>
          <tr [height]="20"></tr>

          <tr>
            <td class="p2Font">Sales</td>
            <td>
              <combo
                #salesCombo
                name="salesValue"
                [ComboData]="comboItems"
                [(ngModel)]="data.salesValue"
                [height]="30"
                [width]="200"
                [label]="''"
                [backgroundColor]="'white'"
                [inputTextClass]="'small-field'"
                [showImg]="false"
                [testId]="'salesCombo'"
              >
              </combo>
            </td>
            <td *ngIf="isNotBlank(data.salesValue)">
              <img-text
                name="salesAdjust"
                [showImg]="false"
                [(ngModel)]="data.salesAdjust"
                [getDisplayValue]="getPercentFieldDisplayValue"
                [height]="30"
                [width]="100"
                [backgroundColor]="'white'"
                [valueType]="'number'"
                [minValue]="-1 | minValue"
                [label]="''"
                [testId]="'salesAdjust'"
              >
              </img-text>
            </td>
          </tr>
          <tr>
            <td class="p2Font" i18n>{{ 'COST_OF_SALES' | translate }}</td>
            <td>
              <combo
                #costsCombo
                name="costsValue"
                [ComboData]="comboItems"
                [(ngModel)]="data.costsValue"
                [height]="30"
                [width]="200"
                [label]="''"
                [backgroundColor]="'white'"
                [inputTextClass]="'small-field'"
                [showImg]="false"
                [testId]="'costsCombo'"
              >
              </combo>
            </td>
            <td *ngIf="isNotBlank(data.costsValue)">
              <img-text
                [showImg]="false"
                name="costsAdjust"
                [(ngModel)]="data.costsAdjust"
                [getDisplayValue]="getPercentFieldDisplayValue"
                [height]="30"
                [width]="100"
                [backgroundColor]="'white'"
                [valueType]="'number'"
                [minValue]="-1 | minValue"
                [label]="''"
                [testId]="'costsAdjust'"
              >
              </img-text>
            </td>
          </tr>
          <tr>
            <td class="p2Font">Salaries</td>
            <td>
              <combo
                #salariesCombo
                name="salariesValue"
                [ComboData]="comboItems"
                [(ngModel)]="data.salariesValue"
                [height]="30"
                [width]="200"
                [label]="''"
                [backgroundColor]="'white'"
                [inputTextClass]="'small-field'"
                [showImg]="false"
                [testId]="'salariesCombo'"
              >
              </combo>
            </td>
            <td *ngIf="isNotBlank(data.salariesValue)">
              <img-text
                [showImg]="false"
                name="salariesAdjust"
                [(ngModel)]="data.salariesAdjust"
                [getDisplayValue]="getPercentFieldDisplayValue"
                [height]="30"
                [width]="100"
                [backgroundColor]="'white'"
                [valueType]="'number'"
                [minValue]="-1 | minValue"
                [label]="''"
                [testId]="'salariesAdjust'"
              >
              </img-text>
            </td>
          </tr>
          <tr>
            <td class="p2Font" i18n>{{ 'OTHER_OPERATING_EXPENSES' | translate }}</td>
            <td>
              <combo
                #expensesCombo
                name="startDateMonth"
                [ComboData]="comboItems"
                [(ngModel)]="data.expensesValue"
                [height]="30"
                [width]="200"
                [label]="''"
                [backgroundColor]="'white'"
                [inputTextClass]="'small-field'"
                [showImg]="false"
                [testId]="'expensesCombo'"
              >
              </combo>
            </td>
            <td *ngIf="isNotBlank(data.expensesValue)">
              <img-text
                [showImg]="false"
                name="expensesAdjust"
                [(ngModel)]="data.expensesAdjust"
                [getDisplayValue]="getPercentFieldDisplayValue"
                [height]="30"
                [width]="100"
                [backgroundColor]="'white'"
                [valueType]="'number'"
                [minValue]="-1 | minValue"
                [label]="''"
                [testId]="'expensesAdjust'"
              >
              </img-text>
            </td>
          </tr>
        </table>
      </div>
      <div [height]="20"></div>
    </div>
  </div>
</form>
